import { SvgIcon, SvgIconProps } from '@cinch-labs/design-system'
import { SharedUiHeaderV2Context } from '../../context/context-shared-ui-header-v2'
import { useContext } from 'react'
import styles from './your-profile-menu.module.css'
import { useUserStore } from '@cinch-nx/data-user'

type ProfilePageLinkProps = {
  icon: SvgIconProps['name']
  title: string
  link: string
  number?: number
  onClick?: () => void
}

const ProfilePageLink: React.FC<ProfilePageLinkProps> = ({
  icon,
  title,
  link,
  number,
  onClick,
}) => {
  const { logicStore } = useContext(SharedUiHeaderV2Context)
  const { handleTrackEvent } = logicStore
  return (
    <a
      href={link}
      onClick={(e) => {
        if (onClick) {
          e.preventDefault()
          onClick()
        }
        handleTrackEvent({
          name: 'click',
          category: 'my profile menu',
          action: title.toLowerCase(),
          label: 'tab selection',
        })
      }}
    >
      <div className={styles.profilePageLinkContainer}>
        {<SvgIcon color="pureBlack" name={icon} />}
        <div className={styles.profilePageLinkTitle}>{title}</div>
        {!!number && <span className={styles.circle}>{number}</span>}
      </div>
    </a>
  )
}

type YourProfileMenuProps = {
  favouritesCount: number
}

export const YourProfileMenu: React.FC<YourProfileMenuProps> = ({
  favouritesCount,
}) => {
  const { logout } = useUserStore()

  return (
    <nav className={styles.yourProfileContainer}>
      <div>
        <ProfilePageLink title={'Your cars'} link="/my-profile" icon={'key'} />
        <ProfilePageLink
          title={'Your part-ex quotes'}
          link="/my-profile/part-exchange"
          icon={'pound'}
        />
        <ProfilePageLink
          title={'Favourites'}
          link="/my-profile/favourites"
          icon={'union'}
          number={favouritesCount}
        />
        <ProfilePageLink
          title={'Car maintenance'}
          link="/my-profile/car-maintenance"
          icon={'wrench'}
        />
        <ProfilePageLink
          title={'Marketing preferences'}
          link="/my-profile/marketing-preferences"
          icon={'letter'}
        />
      </div>
      <div className={styles.bottomSection}>
        <ProfilePageLink
          title={'Account settings'}
          link="/my-profile/account-settings"
          icon={'gear'}
        />
        <ProfilePageLink
          title={'Log out'}
          link="#"
          icon={'logout'}
          onClick={logout}
        />
      </div>
    </nav>
  )
}
